
    // IMPORTS
    import { computed, defineComponent, PropType, ref } from 'vue'

    import { Button } from '@progress/kendo-vue-buttons'
    import { BoolField } from '../fields'

    import { buildLocalization } from '@/util'

    export default defineComponent({
        name: 'lockedOutCell',

        components: {
            BoolField,
            'k-button': Button
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            unlock: (target: InstanceType<typeof Button> | null, username: string) => true
        },

        props: {
            dataItem: { type: Object as PropType<any>, required: true },
            field: { type: String as PropType<string>, required: true },
            className: { type: String as PropType<string>, required: false, default: () => null },
            rowType: { type: String as PropType<string>, required: false, default: () => '' },
            isGroupRender: { type: Boolean as PropType<boolean>, default: () => false },
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const btnUnlock = ref<InstanceType<typeof Button> | null>(null);
            const publicData = { btnUnlock }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const isLockedOut = computed(() => props.dataItem[props.field])
            const computedData = { isLockedOut }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function unlock(username: string) {
                emit('unlock', btnUnlock.value, username)
            }

            const publicMethods = { localize, unlock }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
